import Vue from 'vue';

import {
  LayoutPlugin,
  FormPlugin,
  ButtonPlugin,
  BadgePlugin,
  TabsPlugin,
  BreadcrumbPlugin,
  FormRadioPlugin,
  FormSelectPlugin,
  OverlayPlugin,
  CarouselPlugin,
  ButtonGroupPlugin,
  CardPlugin,
  SkeletonPlugin,
  DropdownPlugin,
  SidebarPlugin,
  FormFilePlugin,
  PaginationPlugin,
  ProgressPlugin,
  PopoverPlugin,
  TablePlugin,
  NavPlugin,
  NavbarPlugin,
  PaginationNavPlugin,
  ImagePlugin,
  SpinnerPlugin,
  FormCheckboxPlugin,
  LinkPlugin,
  ModalPlugin,
  FormTextareaPlugin,
  AlertPlugin,
  FormGroupPlugin,
  FormInputPlugin
} from 'bootstrap-vue';

Vue.use(LayoutPlugin);
Vue.use(FormPlugin);
Vue.use(ButtonPlugin);
Vue.use(BadgePlugin);
Vue.use(TabsPlugin);
Vue.use(BreadcrumbPlugin);
Vue.use(FormRadioPlugin);
Vue.use(FormSelectPlugin);
Vue.use(OverlayPlugin);
Vue.use(CarouselPlugin);
Vue.use(ButtonGroupPlugin);
Vue.use(CardPlugin);
Vue.use(SkeletonPlugin);
Vue.use(DropdownPlugin);
Vue.use(SidebarPlugin);
Vue.use(FormFilePlugin);
Vue.use(PaginationPlugin);
Vue.use(ProgressPlugin);
Vue.use(PopoverPlugin);
Vue.use(TablePlugin);
Vue.use(NavPlugin);
Vue.use(NavbarPlugin);
Vue.use(PaginationNavPlugin);
Vue.use(ImagePlugin);
Vue.use(SpinnerPlugin);
Vue.use(FormCheckboxPlugin);
Vue.use(LinkPlugin);
Vue.use(ModalPlugin);
Vue.use(FormTextareaPlugin);
Vue.use(AlertPlugin);
Vue.use(FormGroupPlugin);
Vue.use(FormInputPlugin);
